<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/8Msmq6/tc-custom/9781501164880.jpg?1730490472490" alt="This image is the cover for the book Department of Temporal Investigations: Shield of the Gods, Star Trek: The Original Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Department of Temporal Investigations: Shield of the Gods, Star Trek: The Original Series
      </h1>
      <p class="bookDescription body article font2">
        <b>An all new <i>Star Trek</i> e-novella featuring the fan-favorite Federation bureau the Department of Temporal Investigations!</b><br/><br/>The stalwart agents of the Department of Temporal Investigations have tracked down many dangerous artifacts, but now they face a greater, more personal challenge: retrieving a time-travel device stolen from their own vault by a rogue agent of the Aegis, a powerful, secretive group that uses its mastery of time to prevent young civilizations from destroying themselves. Blaming the Aegis itself for a tragedy yet to come, this renegade plans to use the stolen artifact to sabotage its efforts in the past, no matter what the cost to the timeline. Now the DTI’s agents must convince the enigmatic Aegis to work alongside them in order to protect history—but they must also wrestle with the potential consequences of their actions, for preserving the past could doom countless lives in the future!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Christopher L. Bennett
      </h2>
      
      <p class="authorDescription body article">Christopher L. Bennett is a lifelong resident of Cincinnati, Ohio, with bachelor&rsquo;s degrees in physics and history from the University of Cincinnati. He has written such critically acclaimed&#160;<I>Star Trek</I>&#160;novels as&#160;<I>Ex&#160;Machina, The Buried Age,</I>&#160;the Titan novels&#160;<I>Orion&rsquo;s Hounds</I>&#160;and&#160;<I>Over a Torrent Sea</I>, the two Department of Temporal Investigations novels&#160;<I>Watching the Clock</I>&#160;and<I>&#160;Forgotten History</I>, and the Enterprise novels&#160;<I>Rise of the Federation: A Choice of Futures</I>,<I>&#160;Tower of Babel</I>,&#160;<I>Uncertain Logic</I>, and&#160;<I>Live By the Code</I>, as well as shorter works including stories in the anniversary anthologies&#160;<I>Constellations, The Sky&rsquo;s the Limit, Prophecy</I>&#160;and&#160;<I>Change</I>, and<I>&#160;Distant Shores</I>. Beyond Star Trek, he has penned the novels&#160;<I>X Men: Watchers on the Walls&#160;</I>and&#160;<I>Spider Man: Drowned in Thunder</I>. His original work includes the hard science fiction superhero novel&#160;<I>Only Superhuman</I>, as well as several novelettes in&#160;<I>Analog</I>&#160;and other science fiction magazines.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Gallery
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7d66f698